const BUTTON_ID='hb-outlet-payment-out';

function cleanup(){
  const buttons=Array.from(document.querySelectorAll(`[id="${BUTTON_ID}"]`));
  if(buttons.length<=1)return;
  buttons.slice(1).forEach(button=>button.remove());
}

function boot(){
  cleanup();
  let queued=false;
  const observer=new MutationObserver(()=>{
    if(queued)return;
    queued=true;
    queueMicrotask(()=>{queued=false;cleanup()});
  });
  observer.observe(document.documentElement,{childList:true,subtree:true});
}

if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});
else boot();
